<template>
    <div>
        <div  class="navdh ">
            <ul class="clear">
                <li class="fl" v-for="item in list.slice(0,this.num)" :key="item.ming">
                    <div @click="open(item)">
                        <svg class="icon" aria-hidden="true">
                            <use :xlink:href="item.name"></use>
                        </svg>
                        <span>{{item.ming}}</span>
                    </div> 
                </li>
                <li class="fl" @click="zhankai" v-if="this.isshow">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icongengduo"></use>
                    </svg>
                    <span>更多</span>
                </li>
                <li class="fl" @click="shouqi" v-if="!this.isshow">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconshouhui"></use>
                    </svg>
                    <span>收起</span>
                </li>
            </ul>            
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            text:'',
            list:[],
            isshow:true,
            num:"9",
            hear:''
        }
    },
    mounted(){
        if(!this.$route.query.identity){
            this.list = [
                {name:'#icontongbukecheng', ming:'同步课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                {name:'#iconzhishidiankecheng', ming:'知识点课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                {name:'#iconzhibokecheng', ming:'直播课程',url:'https://www.gankao.com/live/public'},
                {name:'#iconzhuantikecheng', ming:'专题课程',url:'https://www.rujiaowang.net/mobile/#/CourseDetails'},
            ]
        } else {
            if(this.$route.query.identity == '教师'){
                this.list = [
                    {name:'#icontongbukecheng', ming:'同步课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                    {name:'#iconzhishidiankecheng', ming:'知识点课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                    {name:'#iconzhibokecheng', ming:'直播课程',url:'https://www.gankao.com/live/public'},
                    {name:'#iconzhuantikecheng', ming:'专题课程',url:'https://www.rujiaowang.net/mobile/#/CourseDetails'},
                    {name:'#iconAIzhinengpingce', ming:'AI智能评测',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://ai.gankao.com/evaluation'},
                    {name:'#iconkanzhibo', ming:'看直播',url:'https://www.gankao.com/live/public'},
                    // {name:'#iconpaizhaosouti', ming:'拍照搜题',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://image.gankao.com'},
                    {name:'#iconlianjieke', ming:'衔接课',url:'https://lubo.gankao.com/tag/quwei6'},
                    {name:'#iconjiaoanjiangyi-copy', ming:'教案讲义',url:'https://ziliao.gankao.com/h5?grade=2'},
                    {name:'#iconmianfeike', ming:'免费课',url:'https://lubo.gankao.com/tag/allfree'},
                ]
            } else {
                this.list = [
                    {name:'#icontongbukecheng', ming:'同步课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                    {name:'#iconzhishidiankecheng', ming:'知识点课程',url:'https://www.rujiaowang.net/mobile/#/course'},
                    {name:'#iconzhibokecheng', ming:'直播课程',url:'https://www.gankao.com/live/public'},
                    {name:'#iconzhuantikecheng', ming:'专题课程',url:'https://www.rujiaowang.net/mobile/#/CourseDetails'},
                    {name:'#iconAIzhinengpingce', ming:'AI智能评测',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://ai.gankao.com/evaluation'},
                    {name:'#iconcuotiben', ming:'错题本',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'http://tiku.gankao.com/worngquestion_subject'},
                    {name:'#icontikuzhongxin', ming:'学生自测',
                        url:localStorage.getItem("userInfo") == null ?
                        'https://www.rujiaowang.net/mobile/#/login':
                        'http://www.rujiaowang.net/app/selftest/index.html#/?token='+(JSON.parse(localStorage.getItem("userInfo")).token)
                    },
                    {name:'#iconkanzhibo', ming:'看直播',url:'https://www.gankao.com/live/public'},
                    // {name:'#iconpaizhaosouti', ming:'拍照搜题',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://image.gankao.com'},
                    {name:'#iconcenengli-copy', ming:'测能力',url:localStorage.getItem("userInfo") == null ?'https://www.rujiaowang.net/mobile/#/login':'https://www.gankao.com/home/ceping/m'},
                    {name:'#iconzuowen', ming:'作文',url:'https://www.gankao.com/zuowen/'+
                    (JSON.parse(localStorage.getItem("grade_id"))==0?'1':JSON.parse(localStorage.getItem("grade_id")))},
                    {name:'#icongushiwen-copy', ming:'古诗文',url:'https://www.gankao.com/gushiwen'},
                    {name:'#iconlianjieke', ming:'衔接课',url:'https://lubo.gankao.com/tag/quwei6'},
                    {name:'#iconmianfeike', ming:'免费课',url:'https://lubo.gankao.com/tag/allfree'},
                ]
            }
        }
    },  
    methods:{
        zhankai(){
            this.isshow =false
            this.num = this.list.length
        },
        shouqi(){
            this.isshow =true
            if(this.list.length > '9'){
                this.num = '9'
            } else {
                this.num = this.list.length
            }
        },
        open(item){
            if(localStorage.getItem("pad") == 'true'){
                if(localStorage.getItem("userInfo")){
                    if(item.ming == '拍照搜题'){
                        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
                        AndroidJs.openQuestion(this.userInfo.token)
                    } else if(item.ming == '学生自测'){
                        this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
                        AndroidJs.openTest(this.userInfo.token)
                    } else {
                        window.location.href = item.url
                    }
                } else {
                    window.location.href = item.url
                }
            } else {
                window.location.href = item.url
            }
        }
    }
}
</script>

<style scoped>
.navdh{
    padding: 0 0.2rem;
}
.navdh ul{
    width: 100%;
}
.navdh ul li {
    width: 20%;
    text-align: center;
    margin-top: 0.2rem;
}
.navdh ul li .icon{
    font-size: 32px;
    color: #4E8DF6;
}
.navdh ul li span{
    display: block;
    font-size: 0.32rem;
    text-align: center;
    margin-top: 0.18666rem;
    min-height: 0.75333rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Navdh.vue